import { AddRounded, RemoveRounded } from '@mui/icons-material'
import DeleteIcon from '@mui/icons-material/Delete'
import { Collapse, IconButton, useTheme } from '@mui/material'
import { ReactNode, useRef, useState } from 'react'

interface P {
    head: JSX.Element
    body: ReactNode
    onDelete?: () => void
    /**
     * Disable deletion of obj for and put Editor in view mode
     */
    disableDeletion?: boolean
    defaultOpen?: boolean
}

function TreeViewer({ head, body, onDelete, disableDeletion, defaultOpen }: P) {
    const theme = useTheme()
    const [open, setOpen] = useState(defaultOpen)
    const headRef = useRef<HTMLDivElement>()

    const onNestedLine = () => {
        headRef.current.scrollIntoView({ behavior: 'smooth' })
    }

    return (
        <div style={{ flex: 1 }}>
            <div className='tree-viewer-header-container'>
                <div onClick={() => setOpen(v => !v)}>
                    <IconButton size='small' style={{ border: '1px solid', borderRadius: 4, padding: 4, fontSize: 12 }}>
                        {open && <RemoveRounded sx={{ fontSize: 14 }} />}
                        {!open && <AddRounded sx={{ fontSize: 14 }} />}
                    </IconButton>
                </div>
                <div ref={headRef} className='tree-viewer-header' style={{ backgroundColor: theme.palette.background.smartable }}>
                    {head}
                    {onDelete && (
                        <IconButton className='delete-icon-tree-viewer-header' color='error' onClick={onDelete} disabled={disableDeletion}>
                            <DeleteIcon />
                        </IconButton>
                    )}
                </div>
            </div>
            <Collapse in={open} unmountOnExit>
                <div style={{ display: 'flex', flexDirection: 'row', gap: theme.spacing(1) }}>
                    <div style={{ width: theme.spacing(3), display: 'flex', justifyContent: 'center', cursor: 'pointer' }} onClick={onNestedLine}>
                        <div style={{ flex: 1, maxWidth: 1, borderLeft: '1px dashed var(--border-color)' }} />
                    </div>
                    <div style={{ flex: 1, paddingTop: theme.spacing(2), paddingLeft: theme.spacing(2) }}>
                        {body}
                    </div>
                </div>
            </Collapse>
        </div>
    )
}

export default TreeViewer
